import * as React from 'react';
import { DisplaySectionType } from '../../types/components';
import DisplaySectionField from './DisplaySectionField';
import { TransactionSummaryProps } from '../../types/props';

type DisplaySectionVariant = "card" | "transparent" | "plain" | "header-row" | "bold-value";

const DisplaySection = ({
  sections,
  transactionSummary,
  className,
  variant = "card",
}: {
  sections: DisplaySectionType[];
  transactionSummary?: TransactionSummaryProps;
  className?: string;
  variant?: DisplaySectionVariant;
}) => {
  const renderTransactionSummary = (summary: TransactionSummaryProps) => (
    <div className="text-center">
      <span className="display__block spacing-bottom-xs">{summary.heading}</span>
      <span className="shark-grey display__block spacing-bottom-xs font-regular">{summary.label}</span>
      <span className="display__block spacing-bottom-xs">{summary.value}</span>
    </div>
  )

  return (
    <div className={`display-section display-section--${variant} grid spacing-bottom-small ${className ?? ""}`}>
      {sections.map((section: DisplaySectionType) => (
        <div className="card" key={section.id}>
          <div className="card-header">
            {transactionSummary
              ? renderTransactionSummary(transactionSummary)
              : section.label
            }
          </div>
          <div className="card-body">
            {section.fields.map(field => (
              <DisplaySectionField field={field} key={field.id} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default DisplaySection;